export default "__VITE_ASSET__0acc4cba__"